module.exports = __webpack_public_path__ + "static/media/minus.e1a11bec.svg";